<template>
  <div>
    <div class="d-flex justify-content-between align-items-center">
      <h5 class="headline">EANs</h5>
      <button class="btn btn-outline-info btn-sm shadow-none" @click="addEAN" v-blur-on-click>Add EAN</button>
    </div>
    <ul class="list-group" v-if="product.eans && product.eans.length !== 0">
      <li
        v-for="(eanItem, i) in product.eans"
        :key="i"
        class="list-group-item d-flex justify-content-between align-items-center stock-listing__item"
      >
        <span>
          <span class="badge badge-primary badge-pill mr-2">{{ eanItem.amount }}x</span>
          {{ eanItem.ean }}
        </span>
        <div>
          <!-- <small class="mr-2" v-if="eanItem.createdAt">{{ formatDate(eanItem.createdAt.toDate()) }}</small> -->
          <button class="btn badge badge-secondary badge-pill" @click="deleteEAN(i)">Delete</button>
        </div>
      </li>
    </ul>
    <div class="alert alert-warning" role="alert" v-else>
      No EANs Found
    </div>
  </div>
</template>

<script>
import { db, fb } from '@/shared/firebase'

export default {
  props: ['product'],
  methods: {
    addEAN() {
      const ean = prompt('Scan EAN')
      const amount = prompt('Amount?', 1)
      if (ean && ean) {
        const eanObject = {
          ean,
          amount: parseFloat(amount),
          createdAt: fb.firestore.Timestamp.fromDate(new Date())
        }
        db.doc(`/private/catalog/products/${this.product.id}`).update({
          eans: this.product.eans ? fb.firestore.FieldValue.arrayUnion(eanObject) : [eanObject]
        })
      }
    },
    deleteEAN(i) {
      const confirmed = confirm(`Delete EAN ${this.product.eans[i].ean}?`)
      if (confirmed) {
        const eans = _.cloneDeep(this.product.eans)
        eans.splice(i, 1)
        db.doc(`/private/catalog/products/${this.product.id}`).update({ eans })
      }
    }
  }
}
</script>
